import {createApp} from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import EdModal from '@/features/common/plugins/EdModal';
import {createMetaManager} from 'vue-meta';
import {numberToWithComma} from '@/features/common/utils/numberUtil';
import {loadLanguage, translate} from '@/web/i18n.js';
import {getLanguage} from '@/features/common/utils/languageUtil.js';
import {dateDayFilter, dateFilter, datetimeFilter} from '@iamcommon/front.common/date-util';

async function run() {
    const app = createApp(App);

    await getLanguage(loadLanguage);
    appInit(app);

    app.use(EdModal, {initialize: appInit})
       .mount('#app');
}

function appInit(app) {
    app.config.errorHandler = (err, vm, info) => {
        console.error(err, info);
        if (err.name === 'TypeError') {
            // TypeError 는 발생 시 무시
            return;
        }
        alert(translate(['공통에러_줄바꿈']));
    };

    app.config.globalProperties.$filters = {
        dateFilter,
        dateDayFilter,
        datetimeFilter,
        numberToWithComma,
    };

    app.config.globalProperties.$t = translate;
    app.config.globalProperties.$isExternal = false;

    app.use(router);
    app.use(store);
    app.use(createMetaManager());
}

run();
